/**
 * Count of widgets actually mounted right now.
 *
 * dashboardLayoutsAtom holds every *saved* page's configuration, so summing its
 * activeComponents tells you how much the user has configured overall — not how
 * much is live in the DOM. For memory-pressure signals we need the latter, and
 * jotai atomFamily keys aren't enumerable, so mounting has to be reported
 * explicitly.
 *
 * Registration is centralised in the widget shell rather than done per widget
 * type, so this costs one effect per mounted widget and no subscriptions.
 */

/** `${pageId}:${widgetId}` — page-scoped, since widget ids repeat across pages. */
export type MountedWidgetKey = string

const mounted = new Map<MountedWidgetKey, string>()

export function mountedWidgetKey(pageId: string, widgetId: string): MountedWidgetKey {
  return `${pageId}:${widgetId}`
}

export function registerMountedWidget(key: MountedWidgetKey, kind: string): void {
  mounted.set(key, kind)
}

export function unregisterMountedWidget(key: MountedWidgetKey): void {
  mounted.delete(key)
}

export function getMountedWidgetCount(): number {
  return mounted.size
}

/** Test seam. */
export function resetMountedWidgetsForTest(): void {
  mounted.clear()
}
